import * as bootstrap from 'bootstrap'


function toggleSidebar() {
    const body = document.querySelector('body');
    const isCollapsed = body.classList.contains('collapse-sidebar');
    body.classList.toggle('collapse-sidebar');
    localStorage.setItem('collapse-sidebar', isCollapsed ? 'false' : 'true');
}

window.mightyjs = {
    toggleSidebar
}
